/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/invitePackerAdmin.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { INVITE_PACKER_ADMIN } from "../graphql";
import { VApplication } from "../../../application";
import notification from "../config/notifications.config.json";
import axios from "axios";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface InvitePackerAdminProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  role: string;
}
export interface IInvitePackerAdminMethods extends IPluginMethodMap {
  getInvitePackerAdmin(args: InvitePackerAdminProps): Promise<any>;
}

export class InvitePackerService implements IAgentPlugin {
  readonly methods: IInvitePackerAdminMethods;

  constructor() {
    this.methods = {
      getInvitePackerAdmin: this.getInvitePackerAdmin.bind(this),
    };
  }

  async getInvitePackerAdmin(args: InvitePackerAdminProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: INVITE_PACKER_ADMIN,
          variables: {
            input: {
              invite: args?.invite,
              role: args?.role,
              user: {
                email: args?.email,
                firstName: args?.firstName,
                lastName: args?.lastName,
              },
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createUser,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
